import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  completeLesson,
  sendFeedback,
} from '../../../redux/services/progressService';
import { AnnotationIcon } from '@heroicons/react/solid';
import Rating from '../../../components/Rating';

function Summary() {
  const params = useParams();
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const { t } = useTranslation();
  const navigate = useNavigate();

  const confirmFinish = async () => {
    await sendFeedback(params.courseId, feedback, rating);
    await completeLesson(params.lessonId);
    navigate(`/courses/${params.courseId}`);
  };

  return (
    <section className="w-full h-full flex justify-center items-center">
      <div className="flex flex-col space-y-5 justify-center bg-white rounded-md p-5 shadow-md mt-8">
        <div className="my-3 bg-gradient-to-br from-purple-500 via-sky-light to-sky-dark rounded-md shadow-md w-min text-white p-3">
          <AnnotationIcon className="w-8" />
        </div>
        <p>{t('courses.completed_this_course')}</p>
        <Rating onChange={setRating} rating={rating} />
        <span className="flex-col space-y-5">
          <label>{t('courses.course_summary_provide_feedback')}</label>
          <textarea
            type="text"
            placeholder={'Feedback'}
            className="w-full rounded-md border-none outline-none bg-grey-super_light"
            rows={5}
            onChange={(e) => setFeedback(e.target.value)}
          />
        </span>

        <button
          type="button"
          className="bg-sky text-white rounded-md px-4 py-2 shadow-md hover:bg-sky-dark m-auto"
          onClick={confirmFinish}
        >
          {t('courses.finish_lesson')}
        </button>
      </div>
    </section>
  );
}

Summary.propTypes = {};

export default Summary;
